"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FirmaCosmWasmCwBridgeService = exports.CwBridgeMsgData = void 0;
var FirmaUtil_1 = require("./FirmaUtil");
var CosmWasmTxClient_1 = require("./firmachain/cosmwasm/CosmWasmTxClient");
// staic util
var noFunds = [];
var CwBridgeMsgData = /** @class */ (function () {
    function CwBridgeMsgData() {
    }
    CwBridgeMsgData.getMsgDataChangeOwner = function (new_owner) {
        return JSON.stringify({
            "change_owner": {
                new_owner: new_owner,
            }
        });
    };
    CwBridgeMsgData.getMsgDataAddAuthorizedUser = function (user) {
        return JSON.stringify({
            "add_authorized_user": {
                user: user,
            }
        });
    };
    CwBridgeMsgData.getMsgDataRemoveAuthorizedUser = function (user) {
        return JSON.stringify({
            "remove_authorized_user": {
                user: user,
            }
        });
    };
    CwBridgeMsgData.getMsgDataLock = function () {
        return {
            action: "lock",
            target_addr: ""
        };
    };
    CwBridgeMsgData.getMsgDataDeposit = function (toAddress) {
        return {
            action: "deposit",
            target_addr: toAddress
        };
    };
    CwBridgeMsgData.getMsgDataUnlock = function (token_id) {
        return JSON.stringify({
            "unlock": {
                token_id: token_id,
            }
        });
    };
    CwBridgeMsgData.getMsgDataWithdraw = function (token_id) {
        return JSON.stringify({
            "withdraw": {
                token_id: token_id,
            }
        });
    };
    CwBridgeMsgData.getMsgDataMint = function (owner, token_id, token_uri) {
        return JSON.stringify({
            "mint": {
                token_id: token_id,
                owner: owner,
                extension: {},
                token_uri: token_uri
            }
        });
    };
    return CwBridgeMsgData;
}());
exports.CwBridgeMsgData = CwBridgeMsgData;
var FirmaCosmWasmCwBridgeService = /** @class */ (function () {
    function FirmaCosmWasmCwBridgeService(config, cosmwasmService, cw721Service) {
        this.config = config;
        this.cosmwasmService = cosmwasmService;
        this.cw721Service = cw721Service;
    }
    FirmaCosmWasmCwBridgeService.prototype.getCwBridgeMsgData = function () {
        return CwBridgeMsgData;
    };
    FirmaCosmWasmCwBridgeService.prototype.changeOwner = function (wallet, contractAddress, new_owner, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var msgData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        msgData = CwBridgeMsgData.getMsgDataChangeOwner(new_owner);
                        return [4 /*yield*/, this.cosmwasmService.executeContract(wallet, contractAddress, msgData, noFunds, txMisc)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FirmaCosmWasmCwBridgeService.prototype.getUnsignedTxChangeOwner = function (wallet, contractAddress, new_owner) {
        return __awaiter(this, void 0, void 0, function () {
            var msgData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        msgData = JSON.stringify({
                            "change_owner": {
                                new_owner: new_owner,
                            }
                        });
                        return [4 /*yield*/, this.cosmwasmService.getUnsignedTxExecuteContract(wallet, contractAddress, msgData, noFunds)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FirmaCosmWasmCwBridgeService.prototype.addAuthorizedUser = function (wallet, contractAddress, user, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var msgData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        msgData = CwBridgeMsgData.getMsgDataAddAuthorizedUser(user);
                        return [4 /*yield*/, this.cosmwasmService.executeContract(wallet, contractAddress, msgData, noFunds, txMisc)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FirmaCosmWasmCwBridgeService.prototype.getUnsignedTxAddAuthorizedUser = function (wallet, contractAddress, user) {
        return __awaiter(this, void 0, void 0, function () {
            var msgData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        msgData = CwBridgeMsgData.getMsgDataAddAuthorizedUser(user);
                        return [4 /*yield*/, this.cosmwasmService.getUnsignedTxExecuteContract(wallet, contractAddress, msgData, noFunds)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FirmaCosmWasmCwBridgeService.prototype.removeAuthorizedUser = function (wallet, contractAddress, user, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var msgData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        msgData = CwBridgeMsgData.getMsgDataRemoveAuthorizedUser(user);
                        return [4 /*yield*/, this.cosmwasmService.executeContract(wallet, contractAddress, msgData, noFunds, txMisc)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FirmaCosmWasmCwBridgeService.prototype.getUnsignedTxRemoveAuthorizedUser = function (wallet, contractAddress, user) {
        return __awaiter(this, void 0, void 0, function () {
            var msgData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        msgData = CwBridgeMsgData.getMsgDataRemoveAuthorizedUser(user);
                        return [4 /*yield*/, this.cosmwasmService.getUnsignedTxExecuteContract(wallet, contractAddress, msgData, noFunds)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FirmaCosmWasmCwBridgeService.prototype.lock = function (wallet, contractAddress, cw721ContractAddress, tokenId, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var msgData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        msgData = CwBridgeMsgData.getMsgDataLock();
                        return [4 /*yield*/, this.cw721Service.sendNft(wallet, cw721ContractAddress, contractAddress, tokenId, msgData, txMisc)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FirmaCosmWasmCwBridgeService.prototype.getUnsignedTxLock = function (wallet, contractAddress, cw721ContractAddress, tokenId) {
        return __awaiter(this, void 0, void 0, function () {
            var msgData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        msgData = CwBridgeMsgData.getMsgDataLock();
                        return [4 /*yield*/, this.cw721Service.getUnsignedTxSendNft(wallet, cw721ContractAddress, contractAddress, tokenId, msgData)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FirmaCosmWasmCwBridgeService.prototype.deposit = function (wallet, contractAddress, cw721ContractAddress, tokenId, toAddress, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var msgData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        msgData = CwBridgeMsgData.getMsgDataDeposit(toAddress);
                        return [4 /*yield*/, this.cw721Service.sendNft(wallet, cw721ContractAddress, contractAddress, tokenId, msgData, txMisc)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FirmaCosmWasmCwBridgeService.prototype.getUnsignedTxDeposit = function (wallet, contractAddress, cw721ContractAddress, tokenId, toAddress) {
        return __awaiter(this, void 0, void 0, function () {
            var msgData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        msgData = CwBridgeMsgData.getMsgDataDeposit(toAddress);
                        return [4 /*yield*/, this.cw721Service.getUnsignedTxSendNft(wallet, cw721ContractAddress, contractAddress, tokenId, msgData)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FirmaCosmWasmCwBridgeService.prototype.unlock = function (wallet, contractAddress, token_id, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var msgData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        msgData = CwBridgeMsgData.getMsgDataUnlock(token_id);
                        return [4 /*yield*/, this.cosmwasmService.executeContract(wallet, contractAddress, msgData, noFunds, txMisc)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FirmaCosmWasmCwBridgeService.prototype.getUnsignedTxUnlock = function (wallet, contractAddress, token_id) {
        return __awaiter(this, void 0, void 0, function () {
            var msgData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        msgData = CwBridgeMsgData.getMsgDataUnlock(token_id);
                        return [4 /*yield*/, this.cosmwasmService.getUnsignedTxExecuteContract(wallet, contractAddress, msgData, noFunds)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FirmaCosmWasmCwBridgeService.prototype.withdraw = function (wallet, contractAddress, token_id, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var msgData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        msgData = CwBridgeMsgData.getMsgDataWithdraw(token_id);
                        return [4 /*yield*/, this.cosmwasmService.executeContract(wallet, contractAddress, msgData, noFunds, txMisc)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FirmaCosmWasmCwBridgeService.prototype.getUnsignedTxWithdraw = function (wallet, contractAddress, token_id) {
        return __awaiter(this, void 0, void 0, function () {
            var msgData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        msgData = CwBridgeMsgData.getMsgDataWithdraw(token_id);
                        return [4 /*yield*/, this.cosmwasmService.getUnsignedTxExecuteContract(wallet, contractAddress, msgData, noFunds)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FirmaCosmWasmCwBridgeService.prototype.signAndBroadcast = function (wallet, msgList, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var txClient, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        txClient = new CosmWasmTxClient_1.CosmWasmTxClient(wallet, this.config.rpcAddress);
                        return [4 /*yield*/, txClient.signAndBroadcast(msgList, FirmaUtil_1.getSignAndBroadcastOption(this.config.denom, txMisc))];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        error_1 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_1);
                        throw error_1;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    FirmaCosmWasmCwBridgeService.prototype.getGasEstimationSignAndBroadcast = function (wallet, msgList, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var txClient, txRaw, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        txClient = new CosmWasmTxClient_1.CosmWasmTxClient(wallet, this.config.rpcAddress);
                        return [4 /*yield*/, txClient.sign(msgList, FirmaUtil_1.getSignAndBroadcastOption(this.config.denom, txMisc))];
                    case 1:
                        txRaw = _a.sent();
                        return [4 /*yield*/, FirmaUtil_1.FirmaUtil.estimateGas(txRaw)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_2 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_2);
                        throw error_2;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    // gas
    FirmaCosmWasmCwBridgeService.prototype.getGasEstimationChangeOwner = function (wallet, contractAddress, new_owner) {
        return __awaiter(this, void 0, void 0, function () {
            var msgData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        msgData = CwBridgeMsgData.getMsgDataChangeOwner(new_owner);
                        return [4 /*yield*/, this.cosmwasmService.getGasEstimationExecuteContract(wallet, contractAddress, msgData, noFunds)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FirmaCosmWasmCwBridgeService.prototype.getGasEstimationAddAuthorizedUser = function (wallet, contractAddress, user) {
        return __awaiter(this, void 0, void 0, function () {
            var msgData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        msgData = CwBridgeMsgData.getMsgDataAddAuthorizedUser(user);
                        return [4 /*yield*/, this.cosmwasmService.getGasEstimationExecuteContract(wallet, contractAddress, msgData, noFunds)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FirmaCosmWasmCwBridgeService.prototype.getGasEstimationRemoveAuthorizedUser = function (wallet, contractAddress, user) {
        return __awaiter(this, void 0, void 0, function () {
            var msgData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        msgData = CwBridgeMsgData.getMsgDataRemoveAuthorizedUser(user);
                        return [4 /*yield*/, this.cosmwasmService.getGasEstimationExecuteContract(wallet, contractAddress, msgData, noFunds)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FirmaCosmWasmCwBridgeService.prototype.getGasEstimationLock = function (wallet, contractAddress, cw721ContractAddress, tokenId) {
        return __awaiter(this, void 0, void 0, function () {
            var msgData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        msgData = CwBridgeMsgData.getMsgDataLock();
                        return [4 /*yield*/, this.cw721Service.getGasEstimationSendNft(wallet, cw721ContractAddress, contractAddress, tokenId, msgData)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FirmaCosmWasmCwBridgeService.prototype.getGasEstimationDeposit = function (wallet, contractAddress, cw721ContractAddress, tokenId, toAddress) {
        return __awaiter(this, void 0, void 0, function () {
            var msgData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        msgData = CwBridgeMsgData.getMsgDataDeposit(toAddress);
                        return [4 /*yield*/, this.cw721Service.getGasEstimationSendNft(wallet, cw721ContractAddress, contractAddress, tokenId, msgData)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FirmaCosmWasmCwBridgeService.prototype.getGasEstimationUnlock = function (wallet, contractAddress, token_id) {
        return __awaiter(this, void 0, void 0, function () {
            var msgData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        msgData = CwBridgeMsgData.getMsgDataUnlock(token_id);
                        return [4 /*yield*/, this.cosmwasmService.getGasEstimationExecuteContract(wallet, contractAddress, msgData, noFunds)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FirmaCosmWasmCwBridgeService.prototype.getGasEstimationWithdraw = function (wallet, contractAddress, token_id) {
        return __awaiter(this, void 0, void 0, function () {
            var msgData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        msgData = CwBridgeMsgData.getMsgDataWithdraw(token_id);
                        return [4 /*yield*/, this.cosmwasmService.getGasEstimationExecuteContract(wallet, contractAddress, msgData, noFunds)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    // query
    FirmaCosmWasmCwBridgeService.prototype.getConfig = function (contractAddress) {
        return __awaiter(this, void 0, void 0, function () {
            var query, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        query = "{\"get_config\": {}}";
                        return [4 /*yield*/, this.cosmwasmService.getContractSmartQueryData(contractAddress, query)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, JSON.parse(result)];
                }
            });
        });
    };
    FirmaCosmWasmCwBridgeService.prototype.getOwner = function (contractAddress) {
        return __awaiter(this, void 0, void 0, function () {
            var query, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        query = "{\"get_owner\": {}}";
                        return [4 /*yield*/, this.cosmwasmService.getContractSmartQueryData(contractAddress, query)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, JSON.parse(result)];
                }
            });
        });
    };
    FirmaCosmWasmCwBridgeService.prototype.getAuthorizedUsers = function (contractAddress) {
        return __awaiter(this, void 0, void 0, function () {
            var query, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        query = "{\"get_authorized_users\": {}}";
                        return [4 /*yield*/, this.cosmwasmService.getContractSmartQueryData(contractAddress, query)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, JSON.parse(result)];
                }
            });
        });
    };
    FirmaCosmWasmCwBridgeService.prototype.getNftInfo = function (contractAddress, tokenId) {
        return __awaiter(this, void 0, void 0, function () {
            var query, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        query = "{\"nft_info\": { \"token_id\": \"" + tokenId + "\" }}";
                        return [4 /*yield*/, this.cosmwasmService.getContractSmartQueryData(contractAddress, query)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, JSON.parse(result)];
                }
            });
        });
    };
    FirmaCosmWasmCwBridgeService.prototype.getOwnerNfts = function (contractAddress, ownerAddress, limit, start_after) {
        if (limit === void 0) { limit = 10; }
        if (start_after === void 0) { start_after = ""; }
        return __awaiter(this, void 0, void 0, function () {
            var query, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        query = "{\"owner_nfts\": { \"owner_addr\": \"" + ownerAddress + "\", \"limit\": " + limit + ", \"start_after\": \"" + start_after + "\" }}";
                        return [4 /*yield*/, this.cosmwasmService.getContractSmartQueryData(contractAddress, query)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, JSON.parse(result)];
                }
            });
        });
    };
    FirmaCosmWasmCwBridgeService.prototype.getOwnerNftsInfo = function (contractAddress, ownerAddress, limit, start_after) {
        if (limit === void 0) { limit = 10; }
        if (start_after === void 0) { start_after = ""; }
        return __awaiter(this, void 0, void 0, function () {
            var query, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        query = "{\"owner_nfts_info\": { \"owner_addr\": \"" + ownerAddress + "\", \"limit\": " + limit + ", \"start_after\": \"" + start_after + "\" }}";
                        return [4 /*yield*/, this.cosmwasmService.getContractSmartQueryData(contractAddress, query)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, JSON.parse(result)];
                }
            });
        });
    };
    FirmaCosmWasmCwBridgeService.prototype.getOwnerWithdrawableNfts = function (contractAddress, ownerAddress, limit, start_after) {
        if (limit === void 0) { limit = 10; }
        if (start_after === void 0) { start_after = ""; }
        return __awaiter(this, void 0, void 0, function () {
            var query, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        query = "{\"owner_withdrawable_nfts\": { \"owner_addr\": \"" + ownerAddress + "\", \"limit\": " + limit + ", \"start_after\": \"" + start_after + "\" }}";
                        return [4 /*yield*/, this.cosmwasmService.getContractSmartQueryData(contractAddress, query)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, JSON.parse(result)];
                }
            });
        });
    };
    FirmaCosmWasmCwBridgeService.prototype.getOwnerUnlockableNfts = function (contractAddress, ownerAddress, limit, start_after) {
        if (limit === void 0) { limit = 10; }
        if (start_after === void 0) { start_after = ""; }
        return __awaiter(this, void 0, void 0, function () {
            var query, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        query = "{\"owner_unlockable_nfts\": { \"owner_addr\": \"" + ownerAddress + "\", \"limit\": " + limit + ", \"start_after\": \"" + start_after + "\" }}";
                        return [4 /*yield*/, this.cosmwasmService.getContractSmartQueryData(contractAddress, query)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, JSON.parse(result)];
                }
            });
        });
    };
    FirmaCosmWasmCwBridgeService.prototype.getGlobalTxCounts = function (contractAddress) {
        return __awaiter(this, void 0, void 0, function () {
            var query, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        query = "{\"global_tx_counts\": {}}";
                        return [4 /*yield*/, this.cosmwasmService.getContractSmartQueryData(contractAddress, query)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, JSON.parse(result)];
                }
            });
        });
    };
    return FirmaCosmWasmCwBridgeService;
}());
exports.FirmaCosmWasmCwBridgeService = FirmaCosmWasmCwBridgeService;
